import { computed, ref } from "vue";

const headerHeight = ref(0);
const backAction = ref<() => void>();

const setHeight = (height: number) => {
  headerHeight.value = height;
};

const setBackAction = (action: null | (() => void)) => {
  backAction.value = action ?? undefined;
};

export function useMessengerHeader() {
  return {
    height: computed(() => headerHeight.value),
    setHeight,

    backAction: computed(() => backAction.value),
    setBackAction,
  };
}
